import React from 'react';

const Loader = () => {
    return <div className="loader-wrap"> 
        <div className="spinner-grow text-primary"></div>
    </div>
}

export default Loader;